import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useGetClientPassengersQuery } from '@massilia/queries';
import { Button, Checkbox, Skeleton } from '@massilia/ui';
import { ChevronDown, ChevronUp, Users } from 'lucide-react';
import { useState } from 'react';
import { calculateAge, getGenderLabel } from '../constants/estimate-constants.js';
import { withFieldGroup } from '../hooks/use-app-form.js';
export const ClientPassengerFormGroup = withFieldGroup({
    defaultValues: {},
    props: {},
    render: function Render({ clientId, group }) {
        const { data: passengers, isLoading } = useGetClientPassengersQuery(clientId);
        const [isExpanded, setIsExpanded] = useState(false);
        if (!clientId) {
            return null;
        }
        if (isLoading) {
            return (_jsxs("div", { className: "space-y-2 rounded-lg border border-gray-200 bg-gray-50/50 p-4", children: [_jsx(Skeleton, { className: "h-4 w-48" }), _jsx(Skeleton, { className: "h-10 w-full" })] }));
        }
        if (!passengers || passengers.length === 0) {
            return null;
        }
        const ExpandedIcon = isExpanded ? ChevronUp : ChevronDown;
        return (_jsx(group.AppField, { name: "existingPassengerIds", mode: "array", children: (field) => {
                const fieldValue = field.state.value;
                return (_jsxs("div", { className: "space-y-2 rounded-lg border border-gray-200 bg-gray-50/50 p-4", children: [_jsxs("div", { className: "flex items-center justify-between", children: [_jsxs("label", { className: "flex items-center gap-2 text-sm font-medium text-gray-700", children: [_jsx(Users, { className: "h-4 w-4" }), "Passagers enregistr\u00E9s (", fieldValue?.length ?? 0, "/", passengers.length, " s\u00E9lectionn\u00E9s)"] }), _jsx(Button, { onClick: () => setIsExpanded((prev) => !prev), size: "sm", type: "button", variant: "ghost", children: _jsx(ExpandedIcon, { className: "h-4 w-4" }) })] }), isExpanded && (_jsx("div", { className: "mt-2 grid max-h-64 grid-cols-2 space-y-2 overflow-y-auto", children: passengers.map((passenger) => {
                                const age = calculateAge(passenger.birthDate);
                                const isSelected = fieldValue?.includes(passenger.id);
                                return (_jsxs("div", { className: "flex cursor-pointer items-center space-x-3 rounded p-2 hover:bg-gray-100", children: [_jsx(Checkbox, { checked: isSelected, onClick: (e) => e.stopPropagation(), onCheckedChange: (checked) => {
                                                if (checked === 'indeterminate')
                                                    return;
                                                else if (checked)
                                                    field.pushValue(passenger.id);
                                                else
                                                    field.removeValue(fieldValue?.indexOf(passenger.id) ?? -1);
                                            } }), _jsxs("span", { className: "flex-1 text-sm", children: [passenger.firstName, ' ', _jsx("span", { className: "uppercase", children: passenger.lastName }), " - ", age, " ans (", getGenderLabel(passenger.gender), ")"] })] }, passenger.id));
                            }) }))] }));
            } }));
    },
});
